/**
 * Convert a backend payment failure message into a localized, user-friendly reason.
 *
 * The gateway stores technical strings on the transaction, e.g. "Order status: Declined"
 * (KapitalPaymentGateway emits "Order status: " + <status>). We never surface those raw —
 * map the known order statuses to localized text and fall back to a generic "payment failed"
 * message for anything else (network errors, unmapped statuses, etc.).
 *
 * @param {(key: string, opts?: object) => string} t - i18next translate function
 * @param {string|null|undefined} failureMessage - raw failureMessage from the transaction/result
 * @returns {string} localized failure reason
 */
export function translatePaymentFailure(t, failureMessage) {
  const STATUS_PREFIX = "Order status: ";
  if (failureMessage && failureMessage.startsWith(STATUS_PREFIX)) {
    const status = failureMessage.slice(STATUS_PREFIX.length).trim();
    return t(`pages.invoices.failure.status.${status}`, {
      defaultValue: t("pages.invoices.failure.generic"),
    });
  }
  return t("pages.invoices.failure.generic");
}
